import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsOfService: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Bruksvilkår | Strømkalkulator.no</title>
        <meta name="description" content="Bruksvilkår for Strømkalkulator.no - Les om vilkårene for bruk av vår tjeneste." />
      </Helmet>

      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto bg-white dark:bg-dark-card rounded-lg shadow-sm p-8 dark:border dark:border-dark-border">
          <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">Bruksvilkår</h1>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">1. Aksept av vilkår</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Ved å bruke Strømkalkulator.no aksepterer du disse bruksvilkårene. Hvis du ikke aksepterer vilkårene, 
              ber vi deg om ikke å bruke nettstedet.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">2. Tjenestebeskrivelse</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Strømkalkulator.no er en tjeneste som tilbyr:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 dark:text-gray-300">
              <li>Oversikt over strømpriser i Norge</li>
              <li>Kalkulatorer for beregning av strømforbruk</li>
              <li>Informasjon om strømstøtteordningen</li>
              <li>Prisvarslinger og analyser</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">3. Ansvarsfraskrivelse</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              All informasjon på nettstedet er kun veiledende. Vi garanterer ikke for nøyaktigheten av prisene 
              eller beregningene, og vi kan ikke holdes ansvarlige for beslutninger tatt basert på informasjonen 
              som presenteres.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">4. Opphavsrett</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Alt innhold på Strømkalkulator.no, inkludert tekst, grafikk, logoer, bilder og programvare, 
              er beskyttet av opphavsrett og andre immaterielle rettigheter.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">5. Annonser og tredjepartstjenester</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Nettstedet inneholder annonser fra Google AdSense og kan lenke til tredjepartstjenester. 
              Vi er ikke ansvarlige for innholdet eller personvernpraksisen til disse tjenestene.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">6. Endringer i vilkårene</h2>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              Vi forbeholder oss retten til å endre disse vilkårene når som helst. Betydelige endringer 
              vil bli varslet på nettstedet.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">7. Kontakt</h2>
            <p className="text-gray-700 dark:text-gray-300">
              Har du spørsmål om bruksvilkårene, ta kontakt med oss på{' '}
              <a href="mailto:tor.jetix16@gmail.com" className="text-blue-600 hover:underline dark:text-blue-400">
                tor.jetix16@gmail.com
              </a>
            </p>
          </section>
        </div>
      </main>
    </>
  );
};

export default TermsOfService;